module.exports = function() {
  return new Worker(__webpack_public_path__ + "068f451d9df25293e2dd.worker.js");
};